import _ from "lodash";
import store from "../store/store";
import ColorRange from "./ColorRange";
import ConvertDataArray from "./ConvertDataArray";

export default class ParseTTC {
  static parse(ttc, metrics) {
    let mappedMetrics = metrics.map(row => {
      return ConvertDataArray.convert(row);
    });
    let sizeMin = 1;
    let sizeMax = _.maxBy(mappedMetrics, "size").size;

    let crSize = new ColorRange("size", sizeMin, sizeMax);
    let crRecency = new ColorRange("recency");

    let i;
    let ttcParsed = [];

    _.each(ttc, topic => {
      i = parseInt(topic._id.slice(4));
      let topicRecency = mappedMetrics[i].recency;
      let topicSize = mappedMetrics[i].size;
      let topicNode = {
        id: topic._id,
        type: "topic",
        name: topic.name,
        recency: topicRecency,
        size: topicSize,
        filterSize: null,
        filterRecency: null,
        colors: {
          recency: {
            bg: crRecency.getColors(topicRecency).bgColor
          },
          size: {
            bg: crSize.getColors(topicSize).bgColor
          },
          filter_recency: {
            bg: null
          },
          filter_size: {
            bg: null
          }
        },
        children: []
      };

      _.each(topic.children, theme => {
        i = parseInt(theme._id.slice(4));
        let themeRecency = mappedMetrics[i].recency;
        let themeSize = mappedMetrics[i].size;
        let themeNode = {
          id: theme._id,
          topic_id: topic._id,
          type: "theme",
          name: theme.name,
          recency: themeRecency,
          size: themeSize,
          filterSize: null,
          filterRecency: null,
          colors: {
            recency: {
              bg: crRecency.getColors(themeRecency).bgColor
            },
            size: {
              bg: crSize.getColors(themeSize).bgColor
            },
            filter_recency: {
              bg: null
            },
            filter_size: {
              bg: null
            }
          },
          children: []
        };

        _.each(theme.children, concept => {
          i = parseInt(concept._id.slice(4));
          let conceptRecency = mappedMetrics[i].recency;
          let conceptRecencyColors = crRecency.getColors(conceptRecency);
          let conceptSize = mappedMetrics[i].size;
          let conceptSizeColors = crSize.getColors(conceptSize);
          let conceptNode = {
            id: concept._id,
            topic_id: topic._id,
            theme_id: theme._id,
            type: "concept",
            name: concept.name,
            checked: false,
            recency: conceptRecency,
            size: conceptSize,
            //filter: store.state.filter.filterIndex.find(f => f === concept._id)>-1? true:false,
            filterSize: null,
            filterRecency: null,
            colors: {
              recency: {
                bg: conceptRecencyColors.bgColor,
                text: conceptRecencyColors.textColor
              },
              size: {
                bg: conceptSizeColors.bgColor,
                text: conceptSizeColors.textColor
              },
              filter_recency: {
                bg: null,
                text: null
              },
              filter_size: {
                bg: null,
                text: null
              }
            }
          };
          themeNode.children.push(conceptNode);
        });

        topicNode.children.push(themeNode);
      });
      topicNode.children = this.sortedNode(topicNode.children);
      ttcParsed.push(topicNode);
    });

    return ttcParsed;
  }
  static filterFocus(ttc, metrics) {
    let metricsCopy = JSON.parse(JSON.stringify(metrics)); // Deep copy to prevent vuex mutation errors
    let mappedMetrics = metricsCopy.map(row => {
      return ConvertDataArray.convert(row, "filtdata");
    });
    let sizeMin = 1;
    let sizeMax = _.maxBy(mappedMetrics, "filtsize").filtsize;

    let crSize = new ColorRange("size", sizeMin, sizeMax);
    let crRecency = new ColorRange("recency");

    let i = 0;

    const ttcCopy = JSON.parse(JSON.stringify(ttc)); // Deep copy to prevent vuex mutation errors

    _.each(ttcCopy, topic => {
      i = parseInt(topic.id.slice(4));
      let mappedMetric = mappedMetrics[i];
      topic.colors.filter_size.bg = crSize.getColors(
        mappedMetric.filtsize
      ).bgColor;
      topic.colors.filter_recency.bg = crRecency.getColors(
        mappedMetric.filtrecency
      ).bgColor;
      topic.filterSize = mappedMetric.filtsize;
      topic.filterRecency = mappedMetric.filtrecency;

      _.each(topic.children, theme => {
        //i++;
        i = parseInt(theme.id.slice(4));
        mappedMetric = mappedMetrics[i];
        theme.colors.filter_size.bg = crSize.getColors(
          mappedMetric.filtsize
        ).bgColor;
        theme.colors.filter_recency.bg = crRecency.getColors(
          mappedMetric.filtrecency
        ).bgColor;
        theme.filterSize = mappedMetric.filtsize;
        theme.filterRecency = mappedMetric.filtrecency;

        _.each(theme.children, concept => {
          //i++;
          i = parseInt(concept.id.slice(4));
          mappedMetric = mappedMetrics[i];
          concept.colors.filter_size.bg = crSize.getColors(
            mappedMetric.filtsize
          ).bgColor;
          concept.colors.filter_size.text = crSize.getColors(
            mappedMetric.filtsize
          ).textColor;
          concept.colors.filter_recency.bg = crRecency.getColors(
            mappedMetric.filtrecency
          ).bgColor;
          concept.colors.filter_recency.text = crRecency.getColors(
            mappedMetric.filtrecency
          ).textColor;
          concept.filterSize = mappedMetric.filtsize;
          concept.filterRecency = mappedMetric.filtrecency;
        });
      });

      //i++;
    });

    return ttcCopy;
  }
  static clearFilterFocus(ttc) {
    const ttcCopy = JSON.parse(JSON.stringify(ttc));
    _.each(ttcCopy, topic => {
      topic.colors.filter_size.bg = null;
      topic.colors.filter_recency.bg = null;
      topic.filterSize = null;
      topic.filterRecency = null;

      _.each(topic.children, theme => {
        theme.colors.filter_size.bg = null;
        theme.colors.filter_recency.bg = null;
        theme.filterSize = null;
        theme.filterRecency = null;

        _.each(theme.children, concept => {
          concept.colors.filter_size.bg = null;
          concept.colors.filter_size.text = null;
          concept.colors.filter_recency.bg = null;
          concept.colors.filter_recency.text = null;
          concept.filterSize = null;
          concept.filterRecency = null;
        });
      });
    });

    return ttcCopy;
  }
  static sortedNode(themes) {
    return _.orderBy(themes, "size", "desc");
  }
}
